import { Injectable } from "@angular/core";
import { ReceiptStates } from "../enums/receipt-states.enum";
import { StatusConfig } from "../models/status-config.model";

@Injectable({
  providedIn: "root",
})
export class ReceiptStateService {
  receiptStateConfig: Record<string, StatusConfig> = {
    [ReceiptStates.ATRAI]: {
      bgClass: "bg-status_tag_light",
      iconClass: "pi pi-calendar-clock",
      text: "receiptStatus.comingSoon",
    },
    [ReceiptStates.EMISE]: {
      bgClass: "bg-status_tag_ongoing",
      iconClass: "pi pi-calendar-clock",
      text: "receiptStatus.inProgress",
    },
    [ReceiptStates.SOLDEE]: {
      bgClass: "bg-severity-low",
      iconClass: "pi pi-calendar",
      text: "receiptStatus.paid",
    },
    [ReceiptStates.SANSEF]: {
      bgClass: "bg-status_tag_rejected",
      iconClass: "pi pi-calendar-times",
      text: "receiptStatus.rejected",
    },
    [ReceiptStates.REJ]: {
      bgClass: "bg-status_tag_rejected",
      iconClass: "pi pi-calendar-times",
      text: "receiptStatus.rejected",
    },
    [ReceiptStates.REPRES]: {
      bgClass: "bg-status_tag_ongoing",
      iconClass: "pi pi-calendar-clock",
      text: "receiptStatus.inProgress",
    },
    [ReceiptStates.IMP]: {
      bgClass: "bg-status_tag_unpaid",
      iconClass: "pi pi-calendar-times",
      text: "receiptStatus.unpaid",
    },
    [ReceiptStates.AOFF]: {
      bgClass: "bg-status_tag_offered",
      iconClass: "pi pi-calendar",
      text: "receiptStatus.offered",
    },
    [ReceiptStates.OFFERT]: {
      bgClass: "bg-status_tag_offered",
      iconClass: "pi pi-calendar",
      text: "receiptStatus.offered",
    },
    [ReceiptStates.REGUL]: {
      bgClass: "bg-severity-low",
      iconClass: "pi pi-calendar",
      text: "receiptStatus.paid",
    },
    [ReceiptStates.AVAN]: {
      bgClass: "bg-severity-low",
      iconClass: "pi pi-calendar",
      text: "receiptStatus.paid",
    },
    [ReceiptStates.ANNUL]: {
      bgClass: "bg-severity-high",
      iconClass: "pi pi-calendar-times",
      text: "receiptStatus.canceled",
    },
    [ReceiptStates.ANNUL2]: {
      bgClass: "bg-severity-high",
      iconClass: "pi pi-calendar-times",
      text: "receiptStatus.canceled2",
    },
    [ReceiptStates.RECOUVR]: {
      bgClass: "bg-severity-high",
      iconClass: "pi pi-calendar-times",
      text: "receiptStatus.inCollection",
    },
    [ReceiptStates.ABAND]: {
      bgClass: "bg-severity-high",
      iconClass: "pi pi-calendar-times",
      text: "receiptStatus.abandoned",
    },
  };

  getReceiptStateConfig() {
    return this.receiptStateConfig;
  }

  getStatusClass(status: string): string {
    switch (status) {
      case ReceiptStates.ATRAI:
        return "text-light";
      case ReceiptStates.IMP:
        return "text-severity-high";
      case ReceiptStates.REJ:
        return "text-status_tag_rejected";
      default:
        return "";
    }
  }
}
